import { RefObject } from 'react';
import { useSelector } from 'react-redux';
import SnackbarProfile from '../../components/SnackbarProfile';
import { IRootState } from '../store/model/store.model';

const GlobalSnackbarProfile = () => {
    const isSnackbarProfile: boolean | RefObject<boolean> =
        useSelector((state: { user: IRootState }) => {
            const { user } = state;
            const { isSnackbarProfile } = user;

            return isSnackbarProfile;
        }) ?? false;

    return <>{isSnackbarProfile && <SnackbarProfile />}</>;
};

export default GlobalSnackbarProfile;
